<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 宛先
      span.validation-label 必須
    .register-value.flex-wrap.send-targets
      .loading(v-if="isBusy")
        b-spinner.spinner
        span 宛先読込中...
      button.btn.send-target-select-btn(v-else @click="$emit('show-modal')") 宛先選択
      template(v-for="group in targets")
        template(v-for="resident in group.residents")
          .send-target.d-flex(v-for="family in resident.families" v-if="family.isTarget")
            span.target-name.align-self-center {{ family.familyName }}{{ getSenderType(family.senderType) }}
            b-badge.delete-btn.align-self-center(variant="secondary" @click="$emit('delete-target', family)") X
    .error-messages(v-if="errorMessages && errorMessages.length > 0")
      div(v-for="error in errorMessages")
        label.error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SendMessageTargetGroup } from "@/commons/models/SendMessageTarget";
import { SenderType } from "@/commons/models/Resident";

@Component
export default class SendMessageTargetFamilyRow extends Vue {
  @Prop({ required: true }) targets!: Array<SendMessageTargetGroup> | null;
  @Prop({ required: true }) isBusy!: boolean;
  @Prop({ default: () => [] }) errorMessages!: Array<string>;

  public getSenderType(senderType: SenderType): string {
    if (senderType == SenderType.MAIL) {
      return "（メール）";
    } else {
      return "";
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.send-targets {
  max-width: 600px;

  .send-target-select-btn {
    margin: 0 8px 4px 0;
  }
  .send-target {
    display: inline-block;
    padding: 7px;
    @include font(16px);
    margin: 0 8px 4px 0;
    border-radius: 3px;
    transition: all 0.2s;
    border: 1px solid $form-border-color;

    .target-name {
      margin: 0 8px 0 0 !important;
    }
    .delete-btn {
      margin: 0 !important;
      font-size: 14px !important;
      cursor: pointer;
    }
  }
}
</style>
